import Navbar from "./ui/navbar";
import Footer from "./ui/footer";
import Home from "./modules/Home";
import About from "./modules/About";
import Products from "./modules/Products";
import Services from "./modules/Services";
import Contacts from "./modules/Contacts";
import AuthReseller from "./modules/AuthReseller";
import Partners from "./modules/Partners";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useEffect } from "react";
import { motion as m } from "framer-motion";
import { ToastContainer } from "react-toastify";

function App() {
  const whatsAppPhoneNo = process.env.REACT_APP_WHATSAPP_PHONE_NO;

  return (
    <div className="flex flex-col w-full h-full min-h-screen bg-[#FFFFFF]">
      <m.a
        className="fixed bottom-10 right-5 size-14 items-center justify-center rounded-full bg-[#25D366] p-2 z-20 hover:scale-110 transition-transform duration-100"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.1 }}
        href={`https://wa.me/${whatsAppPhoneNo}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Icon icon="ic:baseline-whatsapp" className="size-full text-white" />
      </m.a>
      <Navbar />
      <Home />
      <AuthReseller />
      <Partners />
      <About />
      <Services />
      <Products />
      <Contacts />
      <Footer />
      <ToastContainer
        position="bottom-center"
        autoClose={2000}
        newestOnTop={false}
        closeOnClick={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;
